import gql from 'graphql-tag';

export { CREATE_LOCATION } from './createLocation';

export const LOCATION_FRAGMENT = gql`
	fragment locationDetailFragment on Location {
		id
		directions
		visualDirectionPhotos {
			id
			link
			comment
		}
		visualDirectionPhotoUrls
		noteCount
		notes {
			id
			description
			created
			isAdminNote
			isImportant
			creator {
				id
				firstname
				lastname
				destroyed
			}
		}
	}
`;

export const GET_LOCATION_NOTES = gql`
	query($id: String) {
		getLocation(id: $id) {
			id
			notes {
				id
				description
				created
				isAdminNote
				isImportant
				creator {
					id
					firstname
					lastname
					destroyed
				}
			}
		}
	}
`;

export const MODIFY_LOCATION = gql`
	mutation modifyLocationMutation($input: ModifyLocationInput!) {
		modifyLocation(input: $input) {
			location {
				...locationDetailFragment
			}
		}
	}
	${LOCATION_FRAGMENT}
`;

export const GET_LOCATION_TAGS = gql`
	query($id: String) {
		getLocation(id: $id) {
			id
			tags {
				id
				name
			}
		}
	}
`;

export const UPDATE_LOCATION_TAGS_MUTATION = gql`
	mutation modifyLocationMutation($input: ModifyLocationInput!) {
		modifyLocation(input: $input) {
			location {
				id
				tags {
					id
					name
				}
			}
		}
	}
`;
